import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'bvl-networks-bar',
  templateUrl: './networks-bar.component.html',
  styleUrls: ['./networks-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NetworksBarComponent {
  inAdmin: boolean;
  showItems = false;

  constructor() {
    this.inAdmin = document.body.classList.contains('admin');
  }

  share(network): void {
    const pageTitle = document.querySelector('title');
    const metaDescription = document.querySelector('meta[name="description"]');
    const title = pageTitle ? (pageTitle as any).text : '';
    const content = metaDescription ? (metaDescription as any).content : '';

    const networkShareUrl = (() => {
      switch (network) {
        case 'linkedin':
          return `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(document.URL)}&title=${title}&summary=${content}`;
        case 'twitter':
          return `https://twitter.com/intent/tweet?url=${encodeURIComponent(document.URL)}&text=${title} - ${content}`;
        case 'facebook':
          return `http://www.facebook.com/sharer.php?u=${encodeURIComponent(document.URL)}&=title=${title}&summary=${content}`;
        default:
          return `mailto:email@address.com?subject=Comparto esta pagina de BVL - ${title}&body=${document.URL}`;
      }
    })();

    window.open(networkShareUrl, '', '_blank, width=500, height=500, resizable=yes, scrollbars=yes');
  }
}
